var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Any other useful information ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("v-textarea", {
                    attrs: {
                      label:
                        "Write anything you think is important about your business that you have not told us",
                      rows: "4",
                      name: "additional",
                      outlined: "",
                      autocomplete: "new-password",
                      "data-vv-as": "Additional",
                      "error-messages": _vm.errors.collect("additional")
                    },
                    model: {
                      value: _vm.additional,
                      callback: function callback($$v) {
                        _vm.additional = $$v
                      },
                      expression: "additional"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }